import gql from 'graphql-tag';
import { parseToMutationRequest } from '../../../utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, [
    'type',
    'index',
    'jurisdiction',
    'taxPercent',
    'minimumThreshold',
    'maximumThreshold',
    'additionalTaxRate',
    'minAccumulatorThreshold',
    'maxAccumulatorThreshold',
    'accumulatorMinTrigger',
  ]);
  const modifyTaxConfig = `modifyTaxConfig(input: ${dataModify})`;
  return gql`
  mutation {
    ${modifyTaxConfig} {
      id
    }
  }
`;
};
